var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16089 9.39452C3.16089 9.39452 2.71698 9.07455 3.24967 8.64733L4.49054 7.53771C4.49054 7.53771 4.84567 7.16412 5.22105 7.48962L16.6725 16.1595V20.317C16.6725 20.317 16.667 20.9698 15.8291 20.8976L3.16089 9.39452Z",
    fill: "#2489CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11252 12.0742L3.1609 14.7576C3.1609 14.7576 2.85752 14.9833 3.1609 15.3865L4.53124 16.6329C4.53124 16.6329 4.85674 16.9825 5.33758 16.5848L8.46677 14.2121L6.11252 12.0742Z",
    fill: "#1070B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2944 12.0964L16.7076 7.963L16.6725 3.82778C16.6725 3.82778 16.4413 2.92525 15.6701 3.39503L8.46674 9.95106L11.2944 12.0964Z",
    fill: "#0877B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8291 20.9032C16.1435 21.225 16.5245 21.1196 16.5245 21.1196L20.743 19.0409C21.283 18.6728 21.2072 18.2161 21.2072 18.2161V5.80291C21.2072 5.25729 20.6486 5.06876 20.6486 5.06876L16.9924 3.30626C16.1935 2.81248 15.6701 3.39504 15.6701 3.39504C15.6701 3.39504 16.3432 2.91054 16.6725 3.82779V20.2411C16.673 20.353 16.6484 20.4636 16.6004 20.5648C16.5042 20.7589 16.2952 20.9402 15.794 20.8643L15.8291 20.9032Z",
    fill: "#3C99D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.c74dc0897797c0b1fb88b301e517bc81.svg";
export { ForwardRef as ReactComponent };